<template>
    <div class="go-in">
        <banner img="bgtop.jpg" :title="$t('about.title')"/>
        <div class="section" v-loading="loading">
            <div class="section-content">
                <div class="content-summary">
                    <div class="summary-left">
                        <p class="title">{{ $t('about.companyIntro') }}</p>
                        <p class="eTitle">ABOUT US:</p>

                        <!-- 中文公司简介 -->
                        <div v-if="$i18n.locale === 'zh'" class="content">
                            广东通创联新技术有限公司（前身为TCL新技术（惠州）有限公司）是一家专注于警用行业产品研发、生产和销售的高新技术企业。公司自成立以来，始终致力于推动执法记录仪行业的技术创新与发展，是全球执法记录仪的开创者和行业领先者。行业贡献与发展历程：
                            <br>
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2006年：公司研发生产全球第一台执法记录仪，开创了执法记录仪行业的先河
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2007年：首创"执法记录仪"这一行业概念，奠定单警执法视音频记录仪的基础
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2008年：TCL新技术公司成立，同年TCL执法记录仪应用于北京奥运会安保工作
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2010年：联合公安举办公安部级执法记录仪评审会，加速行业标准落地
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2011年：基标委第一个企业级委员单位，主导起草第一个行业标准（GA/T 947-2011）
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2015年：作为主要起草人，参与修订行业标准GA/T947-2015
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2016年：入选公安部012采购目录，推出首款4G执法仪，警云可视化指挥调度平台
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2019年：发布行业首批5G执法记录仪，发布国产芯片4G执法记录仪
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2024年：4G/5G执法仪全面升级独立北斗定位，均通过工信部认证
                            <br>
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;十多年来，广东通创联新技术有限公司不仅推动执法记录仪行业的快速发展，还为行业培养大量的专业人才，为执法行业的技术创新和规范化管理作出重要贡献。作为国家高新技术企业和双软企业，依托集团的强大支持与资源整合，公司拥有强大的研发能力，拥有多项发明专利和软件著作权。公司在产品的新工艺、新材料、结构设计等方面拥有自主知识产权，并与国内外知名企业及高校建立了战略合作和联合研究室，持续提升新产品和新技术的研发能力。
                            <br>
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;公司专注于执法记录仪及其他执法装备（数据采集站、枪弹柜、对讲机）的研发与生产，产品广泛应用于公安、交警、应急、交通、法院、检察院、监狱管理局、市场监督管理局、税务、环境监察等多个执法系统。公司不断推出贴近执法实战的执法记录仪，满足不同执法场景的需求。公司秉承"为用户提供最好的产品与服务"的宗旨，坚持"诚信、快捷、热情、专业"的服务理念，致力于为客户提供高效、可靠的执法综合解决方案。
                            <br>
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;按照公安部行标执法记录仪质量要求，公司严格按照ISO9001质量管理体系、ISO14001环境管理体系、ISO45001职业健康安全管理体系执行生产管理。从原材料采购、加工、生产到质量检测及出货，每个环节都严格管控，保障产品的质量。公司以"敬业、诚信、团队、创新"为核心管理理念，不断进取，为员工和客户创造良好的发展环境，推动企业持续健康发展。
                            <br>
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;广东通创联新技术有限公司将继续深耕警用装备行业，依托强大的研发实力和先进的管理理念，不断创新产品和技术，为执法行业提供更优质的解决方案，助力执法行业的智能化、规范化发展。
                        </div>

                        <!-- 英文公司简介 -->
                        <div v-else class="content">
                            Guangdong Tongchuanglian New Technology Co., Ltd. (formerly TCL New Technology (Huizhou) Co., Ltd.) is a high-tech enterprise focusing on the research, development, production and sales of police industry products. Since its establishment, the company has been committed to promoting technological innovation and development in the body camera industry, and is the pioneer and industry leader of global body cameras. Industry contributions and development history:
                            <br>
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2006: The company developed and produced the world's first body camera, pioneering the body camera industry
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2007: Created the industry concept of "body camera", laying the foundation for single police law enforcement audio and video recorders
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2008: TCL New Technology Company was established, and TCL body cameras were applied to Beijing Olympic security work in the same year
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2010: Jointly held the Ministry-level body camera review meeting with public security, accelerating the implementation of industry standards
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2011: The first enterprise-level member unit of the Basic Standards Committee, leading the drafting of the first industry standard (GA/T 947-2011)
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2015: As the main drafter, participated in revising the industry standard GA/T947-2015
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2016: Selected into the Ministry of Public Security 012 procurement catalog, launched the first 4G body camera and Police Cloud visual command and dispatch platform
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2019: Released the industry's first batch of 5G body cameras and domestic chip 4G body cameras
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;2024: 4G/5G body cameras fully upgraded with independent Beidou positioning, all certified by the Ministry of Industry and Information Technology
                            <br>
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;For more than ten years, Guangdong Tongchuanglian New Technology Co., Ltd. has not only promoted the rapid development of the body camera industry, but also cultivated a large number of professional talents for the industry, making important contributions to technological innovation and standardized management in the law enforcement industry. As a national high-tech enterprise and double-soft enterprise, relying on the strong support and resource integration of the group, the company has strong R&D capabilities and holds multiple invention patents and software copyrights. The company has independent intellectual property rights in new processes, new materials, structural design and other aspects of products, and has established strategic cooperation and joint research laboratories with well-known enterprises and universities at home and abroad, continuously improving the R&D capabilities of new products and new technologies.
                            <br>
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;The company focuses on the research and development and production of body cameras and other law enforcement equipment (data collection stations, gun and ammunition cabinets, intercoms). The products are widely used in public security, traffic police, emergency management, transportation, courts, procuratorates, prison administration bureaus, market supervision and administration bureaus, taxation, environmental supervision and other law enforcement systems. The company continues to launch body cameras close to actual law enforcement combat to meet the needs of different law enforcement scenarios. Adhering to the purpose of "providing users with the best products and services" and the service concept of "integrity, speed, enthusiasm and professionalism", the company is committed to providing customers with efficient and reliable comprehensive law enforcement solutions.
                            <br>
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;In accordance with the quality requirements of the Ministry of Public Security's industry standard for body cameras, the company strictly implements production management in accordance with ISO9001 quality management system, ISO14001 environmental management system, and ISO45001 occupational health and safety management system. From raw material procurement, processing, production to quality inspection and shipment, each link is strictly controlled to ensure product quality. With "dedication, integrity, teamwork, and innovation" as the core management philosophy, the company continues to forge ahead, creates a good development environment for employees and customers, and promotes the continuous and healthy development of the enterprise.
                            <br>
                            <br>&nbsp;&nbsp;&nbsp;&nbsp;Guangdong Tongchuanglian New Technology Co., Ltd. will continue to deepen its cultivation in the police equipment industry, rely on strong R&D strength and advanced management concepts, continuously innovate products and technologies, provide better solutions for the law enforcement industry, and help the intelligent and standardized development of the law enforcement industry.
                        </div>

                        <p class="eTitle">{{ $t('about.companyHonor') }}：</p>

                        <!-- 中文公司荣誉 -->
                        <div v-if="$i18n.locale === 'zh'" class="content2">
                            发明专利 31个    质量诚信AAA企业
                            <br>
                            新型专利证书36个    连续四年获警用装备科技创新杰出企业
                            <br>
                            外观专利证书13个    连续四年获警用装备科技创新大奖
                            <br>
                            省级高新技术企业     连续三年获警用装备十大品牌
                            <br>
                            省级守合同重信用企业 公安部社会公共安全应用基础标准化技术委员会 委员单位
                            <br>
                            GA/T 947-2011《单警执法视音频记录仪》主要起草单位
                            <br>
                            GA/T 947.1-2015《单警执法视音频记录系统》主要起草单位
                            <br>
                            五星售后服务认证企业 GB/T 33170《大型活动安全要求》主要起草单位
                        </div>

                        <!-- 英文公司荣誉 -->
                        <div v-else class="content2">
                            31 Invention Patents    Quality Integrity AAA Enterprise
                            <br>
                            36 Utility Model Patents    Outstanding Enterprise in Police Equipment Technology Innovation for Four Consecutive Years
                            <br>
                            13 Design Patents    Grand Award in Police Equipment Technology Innovation for Four Consecutive Years
                            <br>
                            Provincial High-tech Enterprise    Top Ten Brands in Police Equipment for Three Consecutive Years
                            <br>
                            Provincial Contract-abiding and Credit-worthy Enterprise    Member Unit of Ministry of Public Security Social Public Safety Application Basic Standardization Technical Committee
                            <br>
                            Main Drafting Unit of GA/T 947-2011 "Single Police Law Enforcement Audio and Video Recorder"
                            <br>
                            Main Drafting Unit of GA/T 947.1-2015 "Single Police Law Enforcement Audio and Video Recording System"
                            <br>
                            Five-star After-sales Service Certification Enterprise, Main Drafting Unit of GB/T 33170 "Safety Requirements for Large-scale Activities"
                        </div>

                        <p class="eTitle">{{ $t('about.serviceUsers') }}：</p>

                        <!-- 中文服务用户 -->
                        <div v-if="$i18n.locale === 'zh'" class="content2">
                            国家移民局
                            <br>
                            新疆出入境边防检查总站
                            <br>
                            天津市公安局
                            <br>
                            海口出入境边防检查总站
                            <br>
                            上海市公安局
                            <br>
                            宁夏回族自治区公安厅
                            <br>
                            广东省公安厅
                            <br>
                            云南省监狱管理局
                            <br>
                            广西省公安厅
                            <br>
                            广西壮族自治区公安厅
                            <br>
                            山西省公安厅
                            <br>
                            安徽省公安局
                            <br>
                            贵州省公安厅
                            <br>
                            长春市公安局
                            <br>
                            辽宁省公安厅
                            <br>
                            北京市交通执法总队
                            <br>
                            西藏航空
                            <br>
                            济南市公安局交通警察支队
                            <br>
                            中广核集团
                            <br>
                            山西省市场监督管理局
                            <br>
                            河北省应急管理局
                            <br>
                            拉萨市公安局
                            <br>
                            贵州省森林公安局
                            <br>
                            南京市公安局
                        </div>

                        <!-- 英文服务用户 -->
                        <div v-else class="content2">
                            National Immigration Administration
                            <br>
                            Xinjiang Exit-Entry Border Inspection General Station
                            <br>
                            Tianjin Municipal Public Security Bureau
                            <br>
                            Haikou Exit-Entry Border Inspection General Station
                            <br>
                            Shanghai Municipal Public Security Bureau
                            <br>
                            Ningxia Hui Autonomous Region Public Security Department
                            <br>
                            Guangdong Provincial Public Security Department
                            <br>
                            Yunnan Provincial Prison Administration Bureau
                            <br>
                            Guangxi Provincial Public Security Department
                            <br>
                            Guangxi Zhuang Autonomous Region Public Security Department
                            <br>
                            Shanxi Provincial Public Security Department
                            <br>
                            Anhui Provincial Public Security Bureau
                            <br>
                            Guizhou Provincial Public Security Department
                            <br>
                            Changchun Municipal Public Security Bureau
                            <br>
                            Liaoning Provincial Public Security Department
                            <br>
                            Beijing Traffic Law Enforcement General Team
                            <br>
                            Tibet Airlines
                            <br>
                            Jinan Public Security Bureau Traffic Police Detachment
                            <br>
                            China General Nuclear Power Group
                            <br>
                            Shanxi Provincial Market Supervision and Administration Bureau
                            <br>
                            Hebei Provincial Emergency Management Bureau
                            <br>
                            Lhasa Municipal Public Security Bureau
                            <br>
                            Guizhou Provincial Forest Public Security Bureau
                            <br>
                            Nanjing Municipal Public Security Bureau
                        </div>
                    </div>
                    <div class="summary-right">
                        <img :src="getImagePath('tcl1.png')" alt/>
                    </div>
                </div>
                <el-divider class="el-divider-active">
                    <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
                </el-divider>
                <!-- 发展历程 -->
                <div class="content-course">
                    <div class="top">
                        <h3>{{ $t('about.development') }}</h3>
                        <p>DEVELOPMENT</p>
                        <img style="width: 100%" :src="getImagePath('fzlc.png')" alt/>
                        <!--                        <div class="border"></div>-->
                        <div class="timeline"></div>
                    </div>
                    <div class="course-time">
                        <swiper :options="swiperOption" ref="mySwiper">
                            <swiper-slide v-for="(item,index) in courseList" :key="index">
                                <div class="time-show">
                                    <div class="time-show-item" v-for="(courseOne,one) in item" :key="one">
                                        <div class="item-top" :class="{'order-top' : one%2===1}"></div>
                                        <el-divider>
                                            <i class="el-icon-mobile-phone"></i>
                                        </el-divider>
                                        <div class="item-bottom" :class="{'order' : one%2===1}">
                                            <div class="item-bottom-content">
                                                <p class="description">{{ courseOne.Content }}</p>
                                                <p class="year"><strong>{{ courseOne.Year }}</strong></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <div class="swiper-button-prev" slot="button-prev"></div>
                            <div class="swiper-button-next" slot="button-next"></div>
                        </swiper>
                    </div>
                </div>
                <el-divider class="el-divider-active">
                    <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
                </el-divider>
                <!--                <div class="content-culture">-->
                <!--                    <h3>企业文化</h3>-->
                <!--                    <h3>CULTURE</h3>-->
                <!--&lt;!&ndash;                    <p>我们只专注一件事情——工程项目管理</p>&ndash;&gt;-->
                <!--&lt;!&ndash;                    <span>确保工程无重大安全事故</span>&ndash;&gt;-->
                <!--&lt;!&ndash;                    <span>确保工程施工单位无大面积返工</span>&ndash;&gt;-->
                <!--&lt;!&ndash;                    <span>确保工程材料及设备无伪劣产品</span>&ndash;&gt;-->
                <!--&lt;!&ndash;                    <span>确保工程管理留下痕迹、实施过程可追溯</span>&ndash;&gt;-->
                <!--                </div>-->
                <!-- 公司荣誉 -->
                <div class="content-honor">
                    <div class="honor-big-img">
                        <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
                            <img v-lazy="dialogUrl" alt/>
                        </el-dialog>
                    </div>
                    <div class="top">
                        <h3>{{ $t('about.honorTitle') }}</h3>
                        <p>HONOR</p>
                        <div class="border"></div>
                    </div>
                    <ul class="honor-show">
                        <li v-for="(honor,index) in honorList" :key="index">
                            <img v-lazy="imgserver+honor.Img"
                                 @click="dialogTableVisible = true ;dialogUrl = imgserver + honor.Img;dialogTitle= honor.Remark"
                            />
                            <div style="text-align: center">{{ honor.Remark }}</div>
                        </li>
                    </ul>
                    <p style="color:#000;">{{ $t('about.clickToView') }}</p>
                </div>
                <!-- 团队风采 -->
                <!--                <div class="content-team">-->
                <!--                    <div class="top">-->
                <!--                        <h3>团队风采</h3>-->
                <!--                        <p>TEAM</p>-->
                <!--                    </div>-->
                <!--                    <el-carousel :interval="4000" type="card">-->
                <!--                        <el-carousel-item v-for="(team,index) in teamItem" :key="index">-->
                <!--                            <div class="swiper-img" v-lazy:background-image="imgserver + team.Img"></div>-->
                <!--                        </el-carousel-item>-->
                <!--                    </el-carousel>-->
                <!--                </div>-->
                <!-- 合作伙伴 -->
                <!--                <div class="content-partner">-->
                <!--                    <div class="top">-->
                <!--                        <h3>合作伙伴</h3>-->
                <!--                        <p>RARTNERS</p>-->
                <!--                        <ul class="partner-img">-->
                <!--                            <li v-for="(partner,i) in partnerImg" :key="i">-->
                <!--                                <img v-lazy="imgserver+partner.Img" alt/>-->
                <!--                            </li>-->
                <!--                        </ul>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>
        </div>
    </div>
</template>


<script>
import Banner from "../components/Banner";
import {swiper, swiperSlide} from "vue-awesome-swiper";

export default {
    components: {
        Banner,
        swiper,
        swiperSlide
    },
    data() {
        return {
            loading: true,
            honorList: [],
            partnerImg: [],
            courseList: [],
            teamItem: [],
            swiperOption: {
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
            dialogTableVisible: false,
            dialogUrl: "",
            dialogTitle: "",
            imgList:[]
        };
    },
    mounted() {
        this.$http
            .all([
                this.$http.get("Honor/GetHonorAll"),
                this.$http.get("Enterprise/GetEnterpriseAll"),
                this.$http.get(`Team/GetTeamAll`),
                this.$http.get(`Course/GetCourseAll`)
            ])
            .then(
                this.$http.spread(
                    (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
                        this.honorList = responseHonor.data.data;
                        this.partnerImg = responseEnterprise.data.data;
                        this.teamItem = responseTeam.data.data;

                        var groupCount = Math.ceil(responseCourse.data.data.length / 2);
                        window.console.log(groupCount);
                        for (let i = 0; i < groupCount; i++) {
                            let img2 = [];
                            for (let j = 0; j < 2; j++) {
                                if (responseCourse.data.data.length - 1 >= i * 2 + j) {
                                    img2.push(responseCourse.data.data[i * 2 + j]);
                                }
                            }
                            this.courseList.push(img2);
                        }
                        window.console.log(this.courseList);
                        this.loading = false;
                    }
                )
            );
    },
    methods:{

    }
};
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
}

.go-in {
    width: 100%;
    height: 100%;
    //background-color: #14679f;
    position: relative;
    overflow: hidden;

    .section {
        width: 100%;

        &-content {
            width: 1240px;
            margin: 0 auto;
            background-color: #fff;

            .content-summary {
                //height: 500px;
                display: flex;
                justify-content: space-around;
                padding: 100px 0;

                .summary-left {
                    width: 600px;

                    .title {
                        font-size: 25px;
                        color: #e13834;
                    }

                    .eTitle {
                        font-size: 17px;
                        color: #e13834;
                        padding: 20px 0;
                    }

                    .content {
                        color: #14679f;
                        font-size: 14px;
                        text-indent: 25px;
                        line-height: 30px;
                    }
                    .content2 {
                        color: #14679f;
                        font-size: 14px;
                        //text-indent: 25px;
                        line-height: 30px;
                    }
                }

                .summary-right {
                    width: 380px;
                    height: 730px;
                    //border: 2px solid #1d42b9;
                    //animation: imgboxkey 4s infinite;
                    border-radius: 10px;
                    margin-top: 80px;
                    text-align: center;

                    img {
                        width: 340px;
                        height: 690px;
                        margin-top: 20px;
                        //animation: imgbo 4s infinite;
                    }
                }
            }

            //发展历程
            .content-course {
                padding: 50px 0;

                .course-time {
                    width: 1000px;
                    height: 400px;
                    margin: 20px auto;

                    .swiper-container {
                        height: 100%;
                    }

                    .time-show {
                        width: 700px;
                        height: 100%;
                        margin: 0 auto;
                        display: flex;

                        .time-show-item {
                            width: 350px;
                            height: 100%;
                            overflow: hidden;
                            display: flex;
                            flex-direction: column;

                            .item-top,
                            .item-bottom {
                                height: 190px;
                            }

                            .item-bottom {
                                // display: flex;
                                // align-content: center;
                                .item-bottom-content {

                                    margin: 55px 0;

                                    background: linear-gradient(145deg, #f9f9f9, #eaeaea);
                                    border-radius: 12px;
                                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06);
                                    padding: 16px 24px;
                                    max-width: 300px;
                                    transition: transform 0.3s ease, box-shadow 0.3s ease;

                                    &:hover {
                                        transform: translateY(-4px);
                                        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);
                                    }

                                    .description {
                                        font-size: 14px;
                                        line-height: 1.6;
                                        margin-bottom: 8px;
                                        color: red;
                                        text-align: left;
                                    }

                                    .year {
                                        font-size: 16px;
                                        text-align: right;
                                        font-weight: bold;
                                        color: red;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            //企业文化
            .content-culture {
                height: 450px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                padding-left: 100px;
                background-color: #c2daeb;

                h3 {
                    color: #3c6088;
                    font-size: 26px;
                }

                p {
                    color: #3c6088;
                    font-size: 26px;
                    padding: 5px 0;
                }

                span {
                    font-weight: 400;
                    line-height: 36px;
                    font-size: 18px;
                    padding: 5px 0;
                }
            }

            //公司荣誉
            .content-honor {
                padding: 50px 0;

                .honor-show {
                    width: 1000px;
                    margin: 30px auto;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: flex-start;
                    align-content: flex-start;

                    li {
                        width: 283px;
                        height: 244px;
                        margin-left: 15px;
                        list-style: none;
                        //border: 1px solid palegoldenrod;

                        img {
                            width: 100%;
                            height: 194px;
                            cursor: pointer;
                        }
                    }
                }

                p {
                    text-align: center;
                    color: #3c6088;
                }
            }

            //团队风采
            .content-team {
                padding: 50px 100px;

                .swiper-img {
                    height: 400px;
                    background: no-repeat center;
                    background-size: cover;
                }
            }

            //合作伙伴
            .content-partner {
                padding: 50px 0;

                .partner-img {
                    width: 950px;
                    margin: 20px auto;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;

                    li {
                        width: 107px;
                        height: 107px;
                        list-style: none;
                        margin: 10px 25px;

                        img {
                            width: 100%;
                            height: 100%;
                            border: 1px solid rgb(194, 218, 235);
                        }
                    }
                }
            }

            //窄屏适配：iPad / 小笔记本，定宽容器改流式
            @media (max-width: 1280px) {
                width: 100%;
                padding: 0 20px;
                box-sizing: border-box;

                .content-summary {
                    display: block;
                    padding: 30px 0;

                    .summary-left {
                        width: 100%;
                        box-sizing: border-box;
                    }

                    .summary-right {
                        width: 100%;
                        height: auto;
                        margin-top: 20px;
                        box-sizing: border-box;
                    }
                }

                .content-course {
                    .course-time {
                        width: 100%;

                        .time-show {
                            width: 100%;
                        }
                    }
                }

                .content-honor {
                    .honor-show {
                        width: 100%;
                    }
                }
            }

            //窄屏适配：手机
            @media (max-width: 768px) {
                padding: 0 12px;

                .content-summary {
                    padding: 20px 0;

                    .summary-right {
                        img {
                            width: 100%;
                            max-width: 340px;
                            height: auto;
                            margin-top: 0;
                        }
                    }
                }

                .content-course {
                    .course-time {
                        .time-show {
                            .time-show-item {
                                width: 50%;

                                .item-bottom {
                                    .item-bottom-content {
                                        margin: 30px 0;
                                        padding: 10px;
                                        max-width: 100%;

                                        .description {
                                            font-size: 12px;
                                        }

                                        .year {
                                            font-size: 14px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                .content-honor {
                    .honor-show {
                        li {
                            width: 46%;
                            height: auto;
                            margin: 5px 2%;

                            img {
                                height: auto;
                            }
                        }
                    }
                }
            }
        }
    }
}

@keyframes imgboxkey {
    0% {
        border: solid rgb(29, 66, 185) 2px;
    }
    40% {
        border: solid rgb(255, 255, 255) 2px;
    }
    60% {
        border: solid rgb(255, 255, 255) 2px;
    }
    100% {
        border: solid rgb(29, 66, 185) 2px;
    }
}

@keyframes imgbo {
    0% {
        transform: scale(1);
        box-shadow: 0px 0px 0px 0px #ababab;
    }
    50% {
        transform: scale(1.1);
        box-shadow: 0px 0px 10px 5px #ababab;
    }
    100% {
        transform: scale(1);
        box-shadow: 0px 0px 0px 0px #ababab;
    }
}

.el-divider--horizontal {
    margin: 1px 0;
}

.top {
    h3,
    p {
        text-align: center;
        color: #3c6088;
        font-weight: 400;
        padding: 10px 0;
    }

    h3 {
        font-size: 30px;
    }

    p {
        font-size: 20px;
    }

    .border {
        border-bottom: 1px solid #3c6088;
        width: 15%;
        margin: 0 auto;
    }
}

// .swiper-button-disabled {
//   display: none;
// }
.order {
    order: -1;
}

.order-top {
    order: 1;
}

.el-divider {
    background-color: red;
    height: 3px;

    .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
        border: 3px solid red;
    }
}

.el-divider-active {
    background-color: #3c6088;
}

.honor-big-img {
    width: 100%;
    height: 100%;
    z-index: 10;
    text-align: center;
    padding-bottom: 20px;
    padding: 5%;
    //background-color: #14679f;
    .el-dialog__wrapper {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        margin: 0;

        .el-dialog__body {
            overflow: hidden;

            img {
                width: 100%;
            }
        }
    }
}

</style>